import { Guarded, route$navigation } from ":setup/qrouter";
import { Route } from "@solidjs/router";
import { createMemo, Show } from "solid-js";
//
import { checkUserToken, checkPlatformSettings, checkFlavors } from "../SHARED/guards";
import { Loader1 } from ":src/components/loaders";
import { global } from ":shared/app";
import { DashboardLayout } from ":src/layouts";

//
import routes from "./routes";
import { account$signout, Profile, account$profile } from ":src/modules/account";
import { livestage$, virtual_lobby$, focus_room$, LiveStage, VirtualLobby, FocusRoom } from ":src/modules/realtime";
import { schedule$agenda, Agenda } from ":src/modules/schedule";
import { FAQInquiry, help_portal$faq_inquiry } from ":src/modules/help-portal";
import {
  learning_portal$resources,
  learning_portal$mentors,
  learning_portal$workshops,
  Resources,
  Mentors,
  Workshops,
} from ":src/modules/learning-portal";
import {
  teaming$my_team,
  teaming$participants,
  teaming$project_submission,
  teaming$exhibition,
  MyTeam,
  Participants,
  ProjectSubmission,
  SubmissionTimer,
  Exhibition,
} from ":src/modules/teaming";

export default function Participant() {
  const baseRoute = routes.BASE;
  return (
    <Guarded
      // options={{ verbose: true }}
      setup={{
        baseRoute,
        guard: {
          steps: [checkUserToken, checkPlatformSettings, checkFlavors],
        },
        lockedRoutes: {
          [routes.livestage]: () => global.store.actions.platform.getSettingsFor("live_stage").locked,
          [routes.virtaul_lobby]: () => global.store.actions.platform.getSettingsFor("virtual_lobby").locked,
          [routes.focus_room]: () => global.store.actions.platform.getSettingsFor("focus_room").locked,
          [routes.project_submission]: () => global.store.actions.platform.getSettingsFor("submission").locked,
          [routes.workshops]: () => global.store.actions.platform.getSettingsFor("workshops").locked,
        },
      }}
      components={{
        pageNotFound: () => <div>this is Participant page error, this page doesn't exist</div>,
        layout(props) {
          return (
            <Show when={!props.guard.loading()} fallback={<Loader1 subtitle="Participant" msg={props.guard.msg()} />}>
              <DashboardLayout
                childrenTop={[SubmissionTimer()]}
                sideNav={{
                  setup: {
                    baseRoute,
                  },
                  components: {
                    items: [
                      (props) => {
                        return (
                          <div class="flex flex-col w-full h-full overflow-y-auto overflow-x-hidden">
                            {livestage$.Anchors.Side(props)}
                            {virtual_lobby$.Anchors.Side(props)}
                            {schedule$agenda.Anchors.Side(props)}
                            {teaming$my_team.Anchors.Side(props)}
                            {teaming$participants.Anchors.Side(props)}
                            {teaming$project_submission.Anchors.Side(props)}
                            {learning_portal$workshops.Anchors.Side(props)}
                            {learning_portal$mentors.Anchors.Side(props)}
                            {focus_room$.Anchors.Side(props)}
                            {teaming$exhibition.Anchors.Side(props)}
                            {learning_portal$resources.Anchors.Side(props)}
                          </div>
                        );
                      },
                      (props) => {
                        return (
                          <div class="flex flex-col w-full h-fit border-t-2 border-brand border-solid">
                            {help_portal$faq_inquiry.Anchors.Side(props)}
                            {account$profile.Anchors.Side(props)}
                            {account$signout.Anchors.Side(props)}
                          </div>
                        );
                      },
                    ],
                  },
                }}
              >
                <Show when={!props.guard.locked()} fallback={<div>This page is currently locked by admin</div>}>
                  {props.children}
                </Show>
              </DashboardLayout>
            </Show>
          );
        },
      }}
    >
      <Route path={[routes.profile, "/"]} component={Profile} />
      <Route path={routes.faq_inquiry} component={FAQInquiry} />
      {/*  */}
      <Route path={routes.livestage} component={LiveStage} />
      <Route path={routes.virtaul_lobby} component={VirtualLobby} />
      <Route path={routes.focus_room} component={FocusRoom} />
      <Route path={routes.resources} component={Resources} />
      <Route path={routes.mentors} component={Mentors} />
      <Route path={routes.participants} component={Participants} />
      <Route path={routes.exhibition} component={Exhibition} />
      <Route path={routes.agenda} component={Agenda} />
      <Route
        path={routes.project_submission}
        component={() => (
          <ProjectSubmission
            onRouteToCreateTeam={() => {
              global.store.actions.route.navigate(routes.myteam);
            }}
          />
        )}
      />
      <Route path={routes.myteam} component={MyTeam} />
      <Route path={routes.workshops} component={Workshops} />
    </Guarded>
  );
}
